const doc = [({"ko":({"adminConstantHotelInventoryStatus":({"deleted":"삭제됨", "onSale":"판매 중", "saleStopped":"판매 정지"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;